import ptBr from './coverage-params.translations.pt-br.json';

export default {
  'pt-BR': ptBr,
  en: {}
};
